export default "__VITE_ASSET__gAQHeUCI__"